/* eslint-disable max-lines */
import { isProd } from '../../env/enviroment';
export const RXRPropertiesConfig =
 !isProd
    ? [
        {
          name: 'Sawyer Place (50 Nepperhan)',
          'Property Owner': 'RXR Realty',
          id: 4716,
          street: '50 Nepperhan St',
          municipality: 'Yonkers',
          state: 'NY',
          addressNumber: 50,
          postalCode: 10701,
          yearBuilt: 2018,
          CommunityIsGated: 'TRUE',
          noOfUnits: 483,
          'Property Manager': 'Greystar',
          'Property Email': 'sawyerplace@greystar.com',
          complete_address: 'Sawyer Place (50 Nepperhan)',
          communityId: 201453,
        },
        {
          name: 'Sawyer Place (45 Main)',
          'Property Owner': 'RXR Realty',
          id: 3895,
          street: '45 Main St',
          municipality: 'Yonkers',
          state: 'NY',
          addressNumber: 45,
          postalCode: 10701,
          yearBuilt: 2018,
          CommunityIsGated: 'TRUE',
          noOfUnits: 483,
          'Property Manager': 'Greystar',
          'Property Email': 'sawyerplace@greystar.com',
          complete_address: 'Sawyer Place (45 Main)',
          communityId: 201419,
        },
        {
          name: '360 Huguenot',
          'Property Owner': 'RXR Realty',
          id: 3893,
          street: '360 Huguenot St',
          municipality: 'New Rochelle',
          state: 'NY',
          postalCode: 10801,
          yearBuilt: 2019,
          addressNumber: 360,
          CommunityIsGated: 'TRUE',
          noOfUnits: 280,
          'Property Manager': 'Greystar',
          'Property Email': '360huguenot@greystar.com',
          complete_address: '360 Huguenot New Rochelle',
          communityId: 191232,
        },
        {
          name: 'The Willoughby',
          'Property Owner': 'RXR Realty',
          id: 3888,
          street: '196 Willoughby St',
          municipality: 'Brooklyn',
          state: 'NY',
          addressNumber: 196,
          postalCode: 11201,
          yearBuilt: 2021,
          CommunityIsGated: 'TRUE',
          noOfUnits: 476,
          'Property Manager': '',
          'Property Email': 'leasing@willoughbybk.com',
          complete_address: 'The Willoughby Brooklyn',
          communityId: 191234,
        },
        {
          name: '475 Clermont',
          'Property Owner': 'RXR Realty',
          id: 3890,
          street: '475 Clermont Ave',
          municipality: 'Brooklyn',
          state: 'NY',
          postalCode: 11238,
          addressNumber: 475,
          yearBuilt: 2019,
          CommunityIsGated: 'TRUE',
          noOfUnits: 363,
          'Property Manager': '',
          'Property Email': 'info@475clermont.com',
          complete_address: '475 Clermont Brooklyn',
          communityId: 191235,
        },
        {
          name: 'Harbor Landing at Garvies Point (Building I)',
          'Property Owner': 'RXR Realty',
          id: 5007,
          street: '300 Herb Hill Rd',
          municipality: 'Glen Cove',
          state: 'NY',
          addressNumber: 300,
          postalCode: 11542,
          yearBuilt: 2019,
          CommunityIsGated: 'TRUE',
          noOfUnits: 385,
          'Property Manager': 'Greystar',
          'Property Email': 'harborlanding@greystar.com',
          complete_address:
            'Harbor Landing at Garvies Point Glen Cove (Building I)',
          communityId: 206098,
        },
        {
          name: 'Harbor Landing at Garvies Point (Building H)',
          'Property Owner': 'RXR Realty',
          id: 3891,
          street: '350 Herb Hill Rd',
          municipality: 'Glen Cove',
          state: 'NY',
          postalCode: 11542,
          addressNumber: 350,
          yearBuilt: 2019,
          CommunityIsGated: 'TRUE',
          noOfUnits: 385,
          'Property Manager': 'Greystar',
          'Property Email': 'harborlanding@greystar.com',
          complete_address:
            'Harbor Landing at Garvies Point Glen Cove (Building H)',
          communityId: 191236,
        },
        {
          name: 'Atlantic Station West',
          'Property Owner': 'RXR Realty',
          id: 3892,
          street: '405 Atlantic St',
          municipality: 'Stamford',
          state: 'CT',
          addressNumber: 405,
          postalCode: '06901',
          yearBuilt: 2021,
          CommunityIsGated: 'TRUE',
          noOfUnits: 350,
          'Property Manager': 'Korman',
          'Property Email': 'atlanticstation@aveliving.com',
          complete_address: 'Atlantic Station West Stamford',
          communityId: 191238,
        },
        {
          name: 'Atlantic Station',
          'Property Owner': 'RXR Realty',
          id: 3889,
          street: '355 Atlantic St,',
          municipality: 'Stamford',
          state: 'CT',
          addressNumber: 355,
          postalCode: '06901',
          yearBuilt: 2018,
          CommunityIsGated: 'TRUE',
          noOfUnits: 325,
          'Property Manager': 'Korman',
          'Property Email': 'asw@aveliving.com',
          complete_address: 'Atlantic Station Stamford',
          communityId: 191239,
        },
        {
          name: 'Village Square',
          'Property Owner': 'RXR Realty',
          id: 3894,
          street: '100 Village Square',
          municipality: 'Glen Cove',
          state: 'NY',
          postalCode: 11542,
          yearBuilt: 2020,
          CommunityIsGated: 'TRUE',
          addressNumber: 100,
          noOfUnits: 270,
          'Property Manager': 'Greystar',
          'Property Email': 'villagesquare@greystar.com',
          complete_address: 'Village Square Glen Cove',
          communityId: 191240,
        },
        {
          name: 'Magnolia Dumbo (160 Front)',
          'Property Owner': 'RXR Realty',
          id: 3896,
          street: '160 Front St',
          municipality: 'Brooklyn',
          state: 'NY',
          postalCode: 11201,
          yearBuilt: 2022,
          addressNumber: 160,
          CommunityIsGated: 'TRUE',
          noOfUnits: 320,
          'Property Manager': '',
          'Property Email': 'leasing@magnoliadumbo.com',
          complete_address: 'Magnolia Dumbo Brooklyn (160 Front)',
          communityId: 201456,
        },
        {
          name: 'Magnolia Dumbo (135 York)',
          'Property Owner': 'RXR Realty',
          id: 4717,
          street: '135 York Street',
          municipality: 'Brooklyn',
          state: 'NY',
          postalCode: 11201,
          addressNumber: 135,
          yearBuilt: 2022,
          CommunityIsGated: 'TRUE',
          noOfUnits: 160,
          'Property Manager': '',
          'Property Email': 'leasing@magnoliadumbo.com',
          complete_address: 'Magnolia Dumbo Brooklyn (135 York)',
          communityId: 201460,
        },
        {
          name: 'One Clinton Park',
          'Property Owner': 'RXR Realty',
          id: 3897,
          street: '55 Clinton Pl',
          municipality: 'New Rochelle',
          state: 'NY',
          postalCode: 10801,
          addressNumber: 55,
          yearBuilt: 2022,
          CommunityIsGated: 'TRUE',
          noOfUnits: 354,
          'Property Manager': 'Greystar',
          'Property Email': 'oneclintonpark@greystar.com',
          complete_address: 'One Clinton Park New Rochelle',
          communityId: 206480,
        },
        {
          name: 'Vermella Union (1 Vermella Way)',
          'Property Owner': 'RXR Realty',
          id: 4269,
          street: '2 Vermella Wy',
          municipality: 'Union',
          state: 'NJ',
          postalCode: '07083',
          yearBuilt: 2019,
          addressNumber: 2,
          CommunityIsGated: 'TRUE',
          noOfUnits: 2,
          'Property Manager': 'Greystar',
          'Property Email': 'test@theguarantors.com',
          complete_address: 'Vermella Union (1 Vermella Way)',
          communityId: 194985,
        },
      ]
    : [
        {
          name: 'Sawyer Place (50 Nepperhan)',
          'Property Owner': 'RXR Realty',
          id: 12494,
          street: '50 Nepperhan St',
          municipality: 'Yonkers',
          state: 'NY',
          postalCode: 10701,
          yearBuilt: 2018,
          addressNumber: 50,
          CommunityIsGated: 'TRUE',
          noOfUnits: 483,
          'Property Manager': 'Greystar',
          'Property Email': 'sawyerplace@greystar.com',
          complete_address: 'Sawyer Place (50 Nepperhan)',
          communityId: 1090067,
        },
        {
          name: 'Sawyer Place (45 Main)',
          'Property Owner': 'RXR Realty',
          id: 12494,
          street: '45 Main St',
          municipality: 'Yonkers',
          state: 'NY',
          postalCode: 10701,
          yearBuilt: 2018,
          CommunityIsGated: 'TRUE',
          noOfUnits: 483,
          addressNumber: 45,
          'Property Manager': 'Greystar',
          'Property Email': 'sawyerplace@greystar.com',
          complete_address: 'Sawyer Place (45 Main)',
          communityId: 1090070,
        },
        {
          name: '360 Huguenot',
          'Property Owner': 'RXR Realty',
          id: 11480,
          street: '360 Huguenot St',
          municipality: 'New Rochelle',
          state: 'NY',
          postalCode: 10801,
          yearBuilt: 2019,
          CommunityIsGated: 'TRUE',
          noOfUnits: 280,
          addressNumber: 360,
          'Property Manager': 'Greystar',
          'Property Email': '360huguenot@greystar.com',
          complete_address: '360 Huguenot New Rochelle',
          communityId: 1044058,
        },
        {
          name: 'The Willoughby',
          'Property Owner': 'RXR Realty',
          id: 25390,
          street: '196 Willoughby St',
          municipality: 'Brooklyn',
          state: 'NY',
          postalCode: 11201,
          addressNumber: 196,
          yearBuilt: 2021,
          CommunityIsGated: 'TRUE',
          noOfUnits: 476,
          'Property Manager': 'Rose Associates',
          'Property Email': 'leasing@willoughbybk.com',
          complete_address: 'The Willoughby Brooklyn',
          communityId: 1058200,
        },
        {
          name: '475 Clermont',
          'Property Owner': 'RXR Realty',
          id: 11440,
          street: '475 Clermont Ave',
          municipality: 'Brooklyn',
          state: 'NY',
          postalCode: 11238,
          yearBuilt: 2019,
          CommunityIsGated: 'TRUE',
          addressNumber: 475,
          noOfUnits: 363,
          'Property Manager': 'Rose Associates',
          'Property Email': 'info@475clermont.com',
          complete_address: '475 Clermont Brooklyn',
          communityId: 1058198,
        },
        {
          name: 'Harbor Landing at Garvies Point (Building I)',
          'Property Owner': 'RXR Realty',
          id: 11951,
          street: '300 Herb Hill Rd',
          municipality: 'Glen Cove',
          state: 'NY',
          addressNumber: 300,
          postalCode: 11542,
          yearBuilt: 2019,
          CommunityIsGated: 'TRUE',
          noOfUnits: 385,
          'Property Manager': 'Greystar',
          'Property Email': 'harborlanding@greystar.com',
          complete_address:
            'Harbor Landing at Garvies Point Glen Cove (Building I)',
          communityId: 1122028,
        },
        {
          name: 'Harbor Landing at Garvies Point (Building H)',
          'Property Owner': 'RXR Realty',
          id: 11951,
          street: '350 Herb Hill Rd',
          municipality: 'Glen Cove',
          state: 'NY',
          postalCode: 11542,
          addressNumber: 350,
          yearBuilt: 2019,
          CommunityIsGated: 'TRUE',
          noOfUnits: 385,
          'Property Manager': 'Greystar',
          'Property Email': 'harborlanding@greystar.com',
          complete_address:
            'Harbor Landing at Garvies Point Glen Cove (Building H)',
          communityId: 1044066,
        },
        {
          name: 'Atlantic Station West',
          'Property Owner': 'RXR Realty',
          id: 20242,
          street: '405 Atlantic St',
          municipality: 'Stamford',
          state: 'CT',
          postalCode: '06901',
          addressNumber: 405,
          yearBuilt: 2021,
          CommunityIsGated: 'TRUE',
          noOfUnits: 350,
          'Property Manager': 'GreyStar',
          'Property Email': 'asw@aveliving.com',
          complete_address: 'Atlantic Station West Stamford',
          communityId: 1058189,
        },
        {
          name: 'Atlantic Station',
          'Property Owner': 'RXR Realty',
          id: 10119,
          street: '355 Atlantic St',
          municipality: 'Stamford',
          state: 'CT',
          postalCode: '06901',
          addressNumber: 355,
          yearBuilt: 2018,
          CommunityIsGated: 'TRUE',
          noOfUnits: 325,
          'Property Manager': 'Greystar',
          'Property Email': 'atlanticstation@aveliving.com',
          complete_address: 'Atlantic Station Stamford',
          communityId: 1058190,
        },
        {
          name: 'Village Square',
          'Property Owner': 'RXR Realty',
          id: 12495,
          street: '100 Village Square',
          municipality: 'Glen Cove',
          addressNumber: 100,
          state: 'NY',
          postalCode: 11542,
          yearBuilt: 2020,
          CommunityIsGated: 'TRUE',
          noOfUnits: 270,
          'Property Manager': 'Greystar',
          'Property Email': 'villagesquare@greystar.com',
          complete_address: 'Village Square Glen Cove',
          communityId: 1066362,
        },
        {
          name: 'Magnolia Dumbo (160 Front)',
          'Property Owner': 'RXR Realty',
          id: 30641,
          street: '160 Front St',
          municipality: 'Brooklyn',
          state: 'NY',
          addressNumber: 160,
          postalCode: 11201,
          yearBuilt: 2022,
          CommunityIsGated: 'TRUE',
          noOfUnits: 320,
          'Property Manager': '',
          'Property Email': 'leasing@magnoliadumbo.com',
          complete_address: 'Magnolia Dumbo Brooklyn (160 Front)',
          communityId: 1090071,
        },
        {
          name: 'Magnolia Dumbo (135 York)',
          'Property Owner': 'RXR Realty',
          id: 30641,
          street: '135 York Street',
          municipality: 'Brooklyn',
          addressNumber: 135,
          state: 'NY',
          postalCode: 11201,
          yearBuilt: 2022,
          CommunityIsGated: 'TRUE',
          noOfUnits: 160,
          'Property Manager': '',
          'Property Email': 'leasing@magnoliadumbo.com',
          complete_address: 'Magnolia Dumbo Brooklyn (135 York)',
          communityId: 1090076,
        },
        {
          name: 'One Clinton Park',
          'Property Owner': 'RXR Realty',
          id: 32796,
          street: '55 Clinton Pl',
          municipality: 'New Rochelle',
          state: 'NY',
          postalCode: 10801,
          yearBuilt: 2022,
          addressNumber: 55,
          CommunityIsGated: 'TRUE',
          noOfUnits: 354,
          'Property Manager': 'Greystar',
          'Property Email': 'oneclintonpark@greystar.com',
          complete_address: 'One Clinton Park New Rochelle',
          communityId: 1127192,
        },
      ];
